import { TOKENS_COOKIE } from './utils';

export const STORAGES_MAP = {
  local: localStorage,
  session: sessionStorage,
  cookie: {
    getItem: (key: string) => TOKENS_COOKIE.get(key),
    setItem: (key: string, value: string, expires?: Date) =>
      TOKENS_COOKIE.set(key, value, { expires }),
    removeItem: (key: string) => TOKENS_COOKIE.remove(key),
  },
};
